export default __webpack_public_path__ + "static/media/8.94e73b3c.jpg";